<div class="form-section">
  <p>Select a video</p>
  <input
    type="file"
    accept="video/*"
    name="video"
    id="video"
    required="required"
    (change)="videoChanged($event)"
  />
  <div
    class="current-file"
    *ngIf="this.currentFiles.length && !this.files.length"
  >
    <p>Current video: - {{ this.currentFiles[0] }}</p>
  </div>
  <div class="preview-images">
    <div class="caption">
      <p><label for="caption">Caption</label></p>
      <input
        type="text"
        name="caption"
        id="caption"
        placeholder="Caption"
        [(ngModel)]="caption"
        (change)="onCaptionChange()"
        maxlength="30"
      />
      <p class="error" *ngIf="caption.length === 30">Maximum 30 characters</p>
    </div>
  </div>
</div>
